import * as THREE from 'three'
import type { ShotPresentationPose } from './window-gunner-contract'
import { WINDOW_GUNNER_LAYOUT } from './window-gunner-contract'

export interface WindowGunnerFrameObjects {
  root: THREE.Group
  recoil: THREE.Group
  slide: THREE.Mesh
  flash: THREE.Group
  light: THREE.PointLight
}

export function applyWindowGunnerFrame(
  { root, recoil, slide, flash, light }: WindowGunnerFrameObjects,
  pose: ShotPresentationPose,
  delta: number,
  tick: number,
): void {
  root.visible = pose.visible
  if (!pose.visible) {
    root.position.set(-0.42, -0.12, -0.28)
    root.rotation.set(0, 0, 0)
    recoil.rotation.set(0, 0, 0)
    slide.position.set(...WINDOW_GUNNER_LAYOUT.slide)
    flash.visible = false
    light.intensity = 0
    return
  }

  const retract = 1 - pose.extension
  root.position.set(-retract * 0.42, -retract * 0.12, -retract * 0.28)
  const damping = 1 - Math.exp(-delta * 28)
  recoil.rotation.x = THREE.MathUtils.lerp(recoil.rotation.x, -pose.kick * 0.09, damping)
  recoil.rotation.z = THREE.MathUtils.lerp(recoil.rotation.z, pose.kick * 0.035, damping)
  slide.position.z = THREE.MathUtils.lerp(slide.position.z, WINDOW_GUNNER_LAYOUT.slide[2] - pose.slide * 0.075, damping)

  flash.visible = pose.flash > 0.02
  flash.scale.setScalar(0.68 + pose.flash * 0.8)
  flash.rotation.z = tick * 2.399
  light.intensity = pose.flash * 24
}
